module.exports = __webpack_public_path__ + "img/prenotazioni_info.d8a8aa6e.png";